import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Slidell, LA?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through a post office or acceptance clerk in Slidell can take 2–6 months, especially during busy travel seasons. For Northshore commuters, vacation travelers, and families planning Caribbean or European trips, that timeline is simply not viable.",
  },
  {
    q: "Can Northshore commuters and professionals in Slidell get an expedited passport quickly?",
    a: "Absolutely. Slidell's growing professional community — many of whom commute to New Orleans for work — frequently needs expedited passports for business travel, client meetings abroad, and last-minute trips. We regularly process expedited renewals and new applications for Northshore professionals on compressed timelines. Contact us as soon as you confirm your travel date.",
  },
  {
    q: "What if my passport expires before a Gulf Coast cruise or Caribbean vacation?",
    a: "This happens frequently for Slidell families planning Gulf cruises from New Orleans or Mobile. Most cruise lines require your passport to be valid for at least six months beyond your return date. If your expiration is cutting it close, we strongly recommend expedited processing. Standard mail-in renewal through a Slidell post office typically takes 2–6 months — far too long for an upcoming sailing.",
  },
  {
    q: "Can families in Pearl River and Lacombe get expedited passports?",
    a: "Yes. Families throughout St. Tammany Parish — including Pearl River, Lacombe, Folsom, and Covington — have the same access to our expedited services as Slidell residents. Since we operate remotely, your physical location on the Northshore does not affect processing speed. Ship your documents overnight, and we handle the rest. Most clients receive their passports within 2–9 business days.",
  },
  {
    q: "How quickly can Slidell travelers receive an expedited passport?",
    a: "Most Slidell area clients receive their passports within 2–9 business days depending on the processing option selected. Urgent same-day and next-day options are available for travelers with immediate departure needs. Contact us as soon as possible — the sooner you start, the more processing options are available to you.",
  },
  {
    q: "Can retirees and senior travelers in Eden Isle and Lakeshore get expedited passports?",
    a: "Yes — retirees and senior travelers from Eden Isle, Lakeshore, and surrounding Slidell communities are well within our service area. Whether you are planning a European cruise, a Mediterranean tour, or an international family reunion, we make the renewal process straightforward. You do not need to drive into New Orleans for a passport agency appointment. Start online, ship your documents, and we handle the expedited submission.",
  },
  {
    q: "Do I need to visit an office to use Fast Passport Center?",
    a: "No — most Slidell travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Slidell, but that is the point: you do not need one. Start your order online, follow the checklist, and ship your documents overnight from anywhere in St. Tammany Parish.",
  },
  {
    q: "What documents do I need for an expedited passport?",
    a: "Most applicants need: proof of U.S. citizenship (current or expired U.S. passport, birth certificate, or naturalization certificate), a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order, so you know exactly what is required for your specific situation.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability.",
  },
];

export default function SlidellFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Slidell and Northshore travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden">
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i className={`text-white text-sm transition-transform duration-200 ${openIndex === i ? "ri-subtract-line" : "ri-add-line"}`}></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}